// extracted by mini-css-extract-plugin
export default {"security":"Security_security__Ac+lY"};